import type { ItemAyuda } from "@/ui/AyudaVista";

/**
 * El visor de archivos (`ui/VisorArchivo`) se abre desde Evidencias, Correos,
 * la Bitácora y otras vistas. Sus botones son solo ícono y sus atajos vivían
 * en tooltips («Cerrar (Esc)», «Anterior (←)»): aquí van una sola vez para
 * todas las Ayudas que lo abren. Si cambias el visor, cambia esto.
 */

export const VISOR_NAVEGAR: ItemAyuda = {
  label: "Visor: ◀ ▶",
  text: "Pasan al archivo anterior o siguiente sin cerrar el visor. En el celular también puedes deslizar el dedo a los lados.",
};

export const VISOR_DESCARGAR: ItemAyuda = {
  label: "Visor: ↓ Descargar",
  text: "Baja el archivo tal como está guardado: un Word baja como Word aunque aquí lo veas como PDF. Un video que se comprimió baja ya comprimido.",
};

export const VISOR_CERRAR: ItemAyuda = { label: "Visor: ×", text: "Cierra el visor. Tocar afuera no lo cierra." };

/** Items para «Qué hace cada botón» de una vista que abre el visor con varios
 *  archivos. Con uno solo (el PDF de una guía) ◀ ▶ no salen: usa las sueltas. */
export const BOTONES_VISOR: ItemAyuda[] = [VISOR_NAVEGAR, VISOR_DESCARGAR, VISOR_CERRAR];

export const ATAJO_VISOR_FLECHAS: ItemAyuda = {
  label: "← / →",
  text: "Con el visor abierto: archivo anterior o siguiente. Solo mueven el visor, no lo que está detrás.",
};
export const ATAJO_VISOR_ESC: ItemAyuda = {
  label: "Esc",
  text: "Cierra el visor y nada más: la ventana de atrás sigue abierta.",
};

/** Items para «Atajos de teclado» de una vista que abre el visor. */
export const ATAJOS_VISOR: ItemAyuda[] = [ATAJO_VISOR_FLECHAS, ATAJO_VISOR_ESC];
